import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { KsefInvoice } from '../../models/ksef-invoice.model';
import { KsefApiService } from '../../services/ksef-api.service';
import { Roles } from 'src/app/shared/models/auth/role.model';

@Component({
  selector: 'app-ksef-hrnest-settled-list',
  templateUrl: './ksef-hrnest-settled-list.component.html',
})
export class KsefHrnestSettledListComponent implements OnInit {
  invoices$!: Observable<KsefInvoice[]>;
  Roles = Roles;

  constructor(private ksefApi: KsefApiService) {}

  ngOnInit(): void {
    this.invoices$ = this.ksefApi.getHrnestSettledInvoices();
  }
}
